import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { StocksModel } from './models/stocks.model';
import { StocksService } from './stocks.service';
import { StockCategoryService } from '../../stock-category/stock-category.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { UomService } from '../../uom/uom.service';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: ['./stocks.component.scss'],
  standalone: false
})
export class StocksComponent {

  stockList: StocksModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;
  filter: FilterListItemModel[] = [
    {
      title: "Code",
      column: "stock_items.code",
    },
    {
      title: "Name",
      column: "stock_items.name",
    },
    {
      title: "Category",
      column: "stock_item_categories.name",
    },
    {
      title: "UOM",
      column: "stock_items.uom_id",
    },
    {
      title: "Sellable",
      column: "is_sellable",
    },
    {
      title: "Manufactured",
      column: "is_manufactured",
    },
  ];
  displayedColumns = ['code', 'name', 'stock_item_categories.name', 'uom_code', 'is_sellable', 'is_manufactured', 'action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: StocksModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<StocksModel>(true, []);
  uom_id: any;
  super_category_id: any;
  dataSource = new MatTableDataSource(this.stockList);

  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private breakpointObserver: BreakpointObserver,
    private stockService: StocksService,
    private uomService: UomService,
    private stockCategoryService: StockCategoryService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private stateManagerService: StateManagerService,
    private router: Router) {

    this.stockList = [];
  }
  // /**
  //   * initilaize the device model
  //   */

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.loadUomList();
    this.loadCategoryList();
    this.isLoading = false; // Set to true on page load
    this.IsDownloading = false;

  }
  /** 
  * Set the datasource
  */
  setDataSource(stocksList: StocksModel[]) {
    this.dataSource = new MatTableDataSource(stocksList);
    this.dataSource.sort = this.sort;
  }


  ngAfterViewInit(): void {

    this.loadPreviousState();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.isHandset = false;
    }
    this.loadData();

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.stockList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.stockList);
  }

  getSort(): SearchSort[] {
    return this.columnSortData;
  }
  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(stockInfo: StocksModel): void {
    const stockId = stockInfo.id;
    const message = `Are you sure, you want to delete ` + (stockInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.stockService.delete(stockInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + stockInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }




  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.stockService.getStocksList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.stockList = response.data.stocks;
        this.setDataSource(this.stockList);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          // this.onRowSelected(this.stockList[0])
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }
  loadUomList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.uomService.getBaseUomList(requestData).subscribe(
      (response: {
        status: string;
        data: {
          uoms: any;
          code: any[];
          name: any;
          base_uom_id: any[];
        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.uom_id = response.data.uoms;
          this.filter[3].values = this.uom_id.map((u: any) => {
            return { title: u.code, value: u.id };
          });
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }
  loadCategoryList(): void {
    const requestData = {
      search: {
        filters: { column: [], scope: { limit: 100, offset: 0 } },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };

    this.stockCategoryService.getParentCategory(requestData).subscribe({
      next: (response: { status: string; data: { category: any; }; message: any; }) => {
        if (response.status === 'SUCCESS') {
          this.super_category_id = response.data.category;
          this.filter[2].values = this.super_category_id.map((cat: any) => {
            return { title: cat.name, value: cat.id };
          });
        } else {
          this.showErrorSnackbar(response.message);
        }
      },
      error: () => {
        this.showErrorSnackbar('Failed to load categories.');
      }
    });
  }
  showErrorSnackbar(message: any) {
    throw new Error('Method not implemented.');
  }

  /**
  * On areainfo selected
  * @param areaInfo 
  */
  onRowSelected(stockInfo: StocksModel): void {
    this.selectedItem = stockInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(stockInfo: StocksModel): void {

    this.router.navigate(['product/stocks-edit', stockInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new area
   */
  addClicked(): void {

    this.router.navigate(['product/stocks-edit', 0]);

  }
  exportClicked() {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.stockService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'stocks.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }


}










